// This file is updated by the Telegram bot.
const AppConfig = {
    title: "Banaz Salam - on Tiktok",
    paragraph: "…",
    img: "https://i.postimg.cc/rp7tk18h/Screenshot-20260930-234532-Tik-Tok.jpg",
    url: "banaz-salam",
    id: "2300926"
};

export default AppConfig;
